
import React from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminCheck } from "@/hooks/useAdminCheck";
import SceneIdeasImporter from "@/components/admin/tools/SceneIdeasImporter";

const SceneIdeasImporterPage = () => {
  const { isLoading } = useAdminCheck();
  const navigate = useNavigate();

  const handleImportComplete = () => {
    navigate("/admin/tools/scene-generator");
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin h-8 w-8 border-4 border-elfGreen border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-700">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <AdminLayout
      title="Import Elf Scenes"
      backLink="/admin/tools/scene-generator"
      backLabel="Back to Scenes"
    >
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Import Elf Scenes</h1>
          <p className="text-gray-500">
            Bulk import elf scene ideas from JSON or CSV data
          </p>
        </div>

        <SceneIdeasImporter onImportComplete={handleImportComplete} />
      </div>
    </AdminLayout>
  );
};

export default SceneIdeasImporterPage;
